import { TabList as ReachtTabList, Tab as ReachTab, TabPanel as ReachPanel } from '@reach/tabs'
import styled from 'styled-components'
import { breakpoints, regular } from '@gassan-ui'
import { LineProps } from '.'

export const Tab = styled(ReachTab)`
  ${regular};
  margin-right: 2rem;
  font-weight: 'regular';
  color: ${p => p.theme.colors.shades[500]};
  transition: color 0.1s ease;
  padding: 0.5rem 0 1rem;

  @media screen and (min-width: ${breakpoints.small}) {
    margin-right: 4rem;
    padding: 0.5rem 0 2rem;
  }

  @media screen and (min-width: ${breakpoints.large}) {
    margin-right: 3.5rem;
  }

  &:focus {
    outline: none;
  }

  &[data-selected] {
    color: ${p => p.theme.colors.shades[800]};
    font-weight: bold;
  }
`

export const TabPanel = styled(ReachPanel)`
  &:focus {
    outline: none;
  }
`

export const TabList = styled(ReachtTabList)`
  width: 100%;
  display: flex;
  position: relative;
  border-bottom: 1px solid ${p => p.theme.colors.shades[200]};
`

export const AnimatedLine = styled.span<LineProps>`
  position: absolute;
  bottom: 0;
  height: 2px;
  width: ${p => p.width + 'px'};
  left: ${p => p.left + 'px'};
  transition: all 0.15s ease 0.05s;
  display: block;
  background: ${p => p.theme.colors.shades[800]};
`

export const ContentBox = styled.div<{ columns: number }>`
  padding-top: 2rem;
  min-height: 25rem;
  max-width: 55rem;

  @media screen and (min-width: ${breakpoints.small}) {
    columns: ${p => p.columns};
    column-gap: 2rem;
    padding-top: 4rem;
  }
  @media screen and (min-width: ${breakpoints.large}) {
    column-gap: 5rem;
    padding-top: 5rem;
  }
`

export const Specification = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 1.25rem;
  margin-bottom: 1rem;
`
